import { supabase } from "@/integrations/supabase/client";

export type DonationProvider = "venmo" | "paypal";
export type DonationSource = "footer" | "mobile_bar";

/**
 * Logs a donation button click to email_analytics so we can
 * compare conversion between Venmo and PayPal (and where the
 * click originated). Fire-and-forget — never blocks the click.
 */
export const trackDonationClick = (
  provider: DonationProvider,
  source: DonationSource,
) => {
  void supabase.functions.invoke("track-event", {
    body: {
      kind: "analytics",
      event_type: `donation_click_${provider}`,
      campaign_type: "donation",
      campaign_id: source,
      link_url:
        provider === "venmo"
          ? "https://venmo.com/u/roblasa"
          : "https://paypal.me/roblasa",
      event_data: {
        provider,
        source,
        user_agent:
          typeof navigator !== "undefined" ? navigator.userAgent : null,
        referrer: typeof document !== "undefined" ? document.referrer : null,
      },
    },
  })
    .then(({ error }) => {
      if (error) console.error("trackDonationClick failed", error);
    });
};